/*
  Botão "Preferências de cookies" do rodapé.

  O aviso de cookies é da Shopify (privacy-banner.js, carregado por
  content_for_header). Depois que a pessoa escolhe, ele some e não deixa nenhum
  atalho para mudar a escolha. A LGPD pede que retirar o consentimento seja tão
  fácil quanto dar, então este botão reabre o painel de preferências.

  Só aparece quando a API da Shopify existe. Sem ela, fica escondido.
*/
(function () {
  var botao = document.querySelector('[data-preferencias-cookies]');
  if (!botao) return;

  function disponivel() {
    return window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';
  }

  function mostrar() {
    if (disponivel()) botao.hidden = false;
  }

  botao.addEventListener('click', function () {
    if (disponivel()) window.privacyBanner.showPreferences();
  });

  mostrar();
  /* O script da Shopify pode chegar depois do tema. */
  window.addEventListener('load', mostrar);
})();
